import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {ConfigurationProvider} from "../../configuration/configuration";
import {HttpServiceProvider} from "../../http-service/http-service";
import {Shift} from "../../../model/lib/interfaces/Shift";
import {Product} from "../../../model/lib/interfaces/Product";
import {Order} from "../../../model/lib/interfaces/Order";
import {Weekday} from "../../../model/lib/interfaces/Weekday";
import {Service} from "../../../model/lib/interfaces/Service";
import {CustomerAccount} from "../../../model/lib/interfaces/CustomerAccount";

@Injectable()
export class BusinessService {
  constructor(private configurationService: ConfigurationProvider,
              private httpService: HttpServiceProvider) {
  }

  fetchShiftById(shiftId: string): Observable<Shift> {
    return this.httpService.get(this.configurationService.apiUrl() + `business/shift/${shiftId}`)
      .map(data => <Shift>data.json());
  }

  fetchProductsByShiftAndWeekday(shift: Shift, weekday: Weekday): Observable<Product[]> {
    return this.httpService.get(this.configurationService.apiUrl() + `product/shift/${shift.id}/${weekday.dayNr}`)
      .map(data => <Product[]>data.json());
  }

  fetchOrderByShiftAndDate(shift: Shift, date: string): Observable<Order> {
    return this.httpService.get(this.configurationService.apiUrl() + `business/order/shift/${shift.id}/${date}`)
      .map(data => <Order>data.json());
  }

  fetchShiftsByService(service: Service): Observable<Shift[]> {
    return this.httpService.get(this.configurationService.apiUrl() + `business/shift/service/${service.id}`)
      .map(data => <Shift[]>data.json());
  }

  fetchCustomerAccountByCardId(cardId: string): Observable<CustomerAccount> {
    return this.httpService
      .post(this.configurationService.apiUrl() + `business/customer/account/card?nfcCard=${cardId}`, {})
      .map(data => <CustomerAccount>data.json());
  }

  registerNfcCard(customerAccount: CustomerAccount, nfcCard: string) {
    return this.httpService
      .post(this.configurationService.apiUrl() + `business/customer/account/update/nfc`, {id: customerAccount.id, nfcCard: nfcCard});
  }
}



// WEBPACK FOOTER //
// ./src/providers/gastroflow-services/business-service/business-service.ts